var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 5L0 0h9z","fill":"#191815","fillRule":"evenodd"}));
}

Arrow.defaultProps = {"width":"9","height":"5"};

module.exports = Arrow;

Arrow.default = Arrow;
